/**
 * Chat failures the Twilio lifecycle is already recovering from.
 *
 * `api/twilio.ts` funnels every SDK failure through one path, which asks the
 * lifecycle whether it owns the failure — a rebuild queued or running, or a
 * client the SDK declared failed. Those are symptoms of ONE outage the
 * lifecycle handles (and reports itself if it cannot heal it), so the global
 * React Query handlers must not file each one as its own Sentry issue
 * (MYFITWORLD-V2-7M / -80).
 *
 * Its own module, not an export of `twilio.ts`: `globalErrorHandlers` sits in
 * the boot path, and importing the api layer would pull the Twilio SDK in with
 * it. A `WeakSet`, so a marked error nobody holds is not kept alive.
 */
const owned = new WeakSet<object>();

export function markOwnedByChatRecovery(error: unknown) {
  if (typeof error === 'object' && error !== null) owned.add(error);
}

export function isOwnedByChatRecovery(error: unknown) {
  return typeof error === 'object' && error !== null && owned.has(error);
}
